import React from 'react';
import { FeaturedCarousel } from '../FeaturedCarousel';
import { MustReads } from '../MustReads';
import { ActivityFeed } from '../ActivityFeed';
import { RightRail } from '../RightRail';
import { RateWatch } from '../RateWatch';
import { useApp } from '../store';
export function HomePage() {
  const {
    config
  } = useApp();
  const {
    welcome,
    modules
  } = config;
  return <>
      <div className="mb-6 rounded-2xl bg-navy-600 px-6 py-8 sm:px-10 sm:py-10 text-white overflow-hidden relative" data-id="element-484" data-mp="2nx6m63yeurvi">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-gold-500/10" aria-hidden="true" data-id="element-485" data-mp="2ry8mko42d9z2" />
        <div className="pointer-events-none absolute -right-8 bottom-0 h-40 w-40 rounded-full bg-gold-500/5" aria-hidden="true" data-id="element-486" data-mp="2wvs0fmwunkqh" />
        <div className="relative" data-id="element-487" data-mp="12kvecnstz1so">
          {welcome.eyebrow && <p className="text-gold-400 text-xs font-semibold uppercase tracking-[0.2em]" data-id="element-488" data-mp="17iojddiedprd">
              {welcome.eyebrow}
            </p>}
          <h1 className="mt-2 text-3xl sm:text-4xl font-serif font-bold leading-tight" data-id="element-489" data-mp="1jtn8d0kbphx5">
            {welcome.heading}
          </h1>
          {welcome.subtext && <p className="mt-2 max-w-xl text-navy-100 text-sm sm:text-base" data-id="element-490" data-mp="1a1hka1x6zkn8">
              {welcome.subtext}
            </p>}
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-[1fr_340px] gap-6" data-id="element-491" data-mp="15yumzlhr57in">
        <div className="space-y-6 min-w-0" data-id="element-492" data-mp="22q59g8l2au62">
          <FeaturedCarousel data-id="element-493" data-mp="1xs3h0x1qxihx" />
          {modules.mustReads && <MustReads data-id="element-494" data-mp="1xsd9qse6e3rb" />}
          <ActivityFeed compact data-id="element-495" data-mp="1xq0skhg8rxfb" />
        </div>
        <div className="xl:block space-y-6" data-id="element-496" data-mp="1tp73vluz6eld">
          {modules.rateWatch && <RateWatch data-id="element-497" data-mp="1orfbyrubysh6" />}
          <RightRail data-id="element-498" data-mp="1oryi7bambsfd" />
        </div>
      </div>
    </>;
}